import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

function RouteGuard({ children }) {
  const [showDialog, setShowDialog] = React.useState(false);
  const [pendingPath, setPendingPath] = React.useState(null);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    if (localStorage.getItem('competitionStarted') === 'true') {
      setPendingPath(path);
      setShowDialog(true);
    } else {
      navigate(path);
    }
  };

  return (
    <>
      {React.Children.map(children, child =>
        React.cloneElement(child, { onNavigate: handleNavigation })
      )}

      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <DialogTitle>Atenção</DialogTitle>
        <DialogContent>
          Há uma competição em andamento. Deseja realmente sair desta página?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDialog(false)}>Cancelar</Button>
          <Button 
            onClick={() => {
              setShowDialog(false);
              if (pendingPath) navigate(pendingPath);
            }} 
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RouteGuard;